import { Grid } from '@mui/material'
import { SeccionComentarios } from '../components/SeccionComentarios'
import { useOperacion } from '../hooks/useOperacion'

export const Comentarios = () => {

    const { idOperacion, codSistemaTipo: codSistema } = useOperacion()

    return (
        <Grid container spacing={4}>
            <Grid item xs={12}>
                <SeccionComentarios
                    idOperacion={idOperacion}
                    codSistema={codSistema}
                />
            </Grid>
        </Grid>
    )
}
